import { render, staticRenderFns } from "./TentDropdownItem.vue?vue&type=template&id=edde9dd4&scoped=true"
import script from "./TentDropdownItem.vue?vue&type=script&lang=ts"
export * from "./TentDropdownItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edde9dd4",
  null
  
)

export default component.exports